import React from "react";
import PropTypes from "prop-types";

/** Ship Clues / admin theme — logo blues + magenta accent */
export const shipCluesGradientColors = {
  primary: "#1b5fcc",
  secondary: "#263f97",
  accent: "#d557aa",
};

const BorderRotate = ({
  children,
  className = "",
  animationMode = "auto-rotate",
  animationSpeed = 5,
  gradientColors = shipCluesGradientColors,
  backgroundColor = "#ffffff",
  borderWidth = 2,
  borderRadius = 20,
  style = {},
  ...props
}) => {
  const { primary, secondary, accent } = gradientColors;

  const animationClass =
    animationMode === "auto-rotate"
      ? "gradient-border-auto"
      : animationMode === "rotate-on-hover"
        ? "gradient-border-hover"
        : animationMode === "stop-rotate-on-hover"
          ? "gradient-border-stop-hover"
          : "";

  const combinedStyle = {
    "--animation-duration": `${animationSpeed}s`,
    "--border-width": `${borderWidth}px`,
    "--border-radius": `${borderRadius}px`,
    border: `${borderWidth}px solid transparent`,
    borderRadius: `${borderRadius}px`,
    backgroundImage: `
      linear-gradient(${backgroundColor}, ${backgroundColor}),
      conic-gradient(
        from var(--gradient-angle, 0deg),
        ${primary} 0%,
        ${secondary} 28%,
        ${accent} 52%,
        ${secondary} 72%,
        ${primary} 100%
      )
    `,
    backgroundClip: "padding-box, border-box",
    backgroundOrigin: "padding-box, border-box",
    ...style,
  };

  return (
    <div
      className={`gradient-border-component ${animationClass} ${className}`.trim()}
      style={combinedStyle}
      {...props}
    >
      {children}
    </div>
  );
};

BorderRotate.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  animationMode: PropTypes.oneOf([
    "auto-rotate",
    "rotate-on-hover",
    "stop-rotate-on-hover",
  ]),
  animationSpeed: PropTypes.number,
  gradientColors: PropTypes.shape({
    primary: PropTypes.string.isRequired,
    secondary: PropTypes.string.isRequired,
    accent: PropTypes.string.isRequired,
  }),
  backgroundColor: PropTypes.string,
  borderWidth: PropTypes.number,
  borderRadius: PropTypes.number,
  style: PropTypes.object,
};

export { BorderRotate };
export default BorderRotate;
